@import '~style-sheet-helpers/core.less';
@import '../../../app-brand/entities/entity-layer.module.less';
@import (reference) '../settings-page.module.less';
@import '../../../constants/spacing.module.less';

.content {
  width: 750px;
}

.grid {
  display: block;
  margin-top: @space-16;
  border: @settings-page--table--border;
  border-bottom: none;
  font-size: @settings-page--table--font-size;
  line-height: @settings-page--table--line-height;
  width: 100%;
  background-color: @settings-page--table--body--cell--background-color;
  color: @settings-page--table--body--cell--text-color;
}

.grid-header {
  background-color: @settings-page--table--header--cell--background-color;
  font-weight: @settings-page--table--header--cell--font-weight;
  color: @settings-page--table--header--cell--text-color;
}

.grid-header,
.row {
  display: grid;
  border-bottom: @settings-page--table--border;
  line-height: 1.5;
  align-items: center;

  &:hover {
    background-color: @settings-page--inventory-warehouse-grid-row--hover--background-color;
  }
}

.grid--with-totes .grid-header,
.grid--with-totes .row {
  grid-template-columns: 1fr 1fr 1fr 1fr 80px;
}

.grid--no-totes .grid-header,
.grid--no-totes .row {
  grid-template-columns: 1fr 1fr 80px;
}

.name-row {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  padding: @settings-page--table--cell--padding;
}

.locations-row {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  padding: @settings-page--table--cell--padding;
}

.totes-row {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  padding: @settings-page--table--cell--padding;
}

.is-linked-row {
  text-align: left;
  padding: @settings-page--table--cell--padding;
}

.link-button {
  color: var(--blue-600);
}

.checkmark {
  height: 14px;
  width: 14px;
  color: @settings-page--inventory-warehouse-check--icon-color;
}

.action-buttons-wrapper {
  display: flex;
  justify-content: center;
  padding: @settings-page--table--cell--padding;
}

.menu-toggle {
  height: @space-32;
  width: @space-32;
  border-radius: 6px;
  color: @settings-page--inventory-warehouse-menu--text-color;

  &:hover,
  &:focus {
    background-color: @settings-page--inventory-warehouse-menu--hover--background-color;
    color: @settings-page--inventory-warehouse-menu--hover--text-color;
  }

  &:active {
    background-color: @settings-page--inventory-warehouse-menu--active--background-color;
    color: @settings-page--inventory-warehouse-menu--active--text-color;
  }
}

.open-menu-toggle {
  background-color: @settings-page--inventory-warehouse-open-menu--background-color;
  color: @settings-page--inventory-warehouse-open-menu--text-color;
}

.menu-toggle-contents {
  display: flex;
  align-items: center;
  justify-content: center;

  & > svg {
    width: @space-16;
  }
}

.add-inventory-warehouse-button {
  margin-top: @space-16;
  text-align: right;
  svg {
    width: @space-16;
    height: @space-16;
    margin-right: @space-4;
  }
}

.loading-container {
  justify-content: center;
  align-items: center;
  padding: @space-40 @space-0;
  min-height: 300px;
}

.loading-indicator {
  height: 100px;
  width: 100px;
}
